import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=3c7d16d2&"
import script from "./inquiry.vue?vue&type=script&lang=js&"
export * from "./inquiry.vue?vue&type=script&lang=js&"
import style0 from "./inquiry.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports